import Vue from 'vue'
import { USER_INFO, ENHANCE_PRE } from '@/store/mutation-types'

const getters = {
  language: state => state.app.language,
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => {
    state.user.avatar = Vue.ls.get(USER_INFO).avatar
    return state.user.avatar
  },
  username: state => state.user.username,
  nickname: state => {
    state.user.realname = Vue.ls.get(USER_INFO).realname
    return state.user.realname
  },
  welcome: state => state.user.welcome,
  permissionList: state => state.user.permissionList,
  userInfo: state => {
    state.user.info = Vue.ls.get(USER_INFO)
    return state.user.info
  },
  addRouters: state => state.permission.addRouters,
  onlAuthFields: state => state.online.authFields,
  // 在线表单中数据多语言字段值
  langFieldMap: state => state.online.langFieldMap,
  // 主表列表数据多语言字段
  tableLangField: state => state.online.tableLangField,
  // 子表列表
  subLangField: state => state.online.subLangField,
  // 列表数据多语言信息
  tableLangMap: state => state.online.tableLangMap,
  // 获取对应表下开启多语言字段的后端返回的源数据
  tableSourceLangMap: state => state.online.langFieldSourceMap,
  enhanceJs: (state) => (code) => {
    state.enhance.enhanceJs[ code ] = Vue.ls.get(ENHANCE_PRE + code)
    return state.enhance.enhanceJs[ code ]
  }

}

export default getters
